import { supabase } from '../../supabase';
import { ensureGymId } from '../receptionist/gymContext';

/** Map get_z_report_totals RPC payload → buildDailyZSheetAuto shape (sale/payment fields). */
export function mapZReportRpcToAuto(data) {
  if (!data || data.error) return null;
  const saleSummary = (data.sale_summary || []).map((row) => ({
    id: row.id,
    label: row.label,
    note: row.note || '',
    count: Number(row.count) || 0,
    value: Number(row.value) || 0,
  }));
  const paymentMethods = (data.payment_methods || []).map((row) => ({
    id: row.id,
    label: row.label,
    tender: row.label,
    amount: Number(row.amount) || 0,
    count: Number(row.count) || 0,
  }));
  return {
    saleSummary,
    totalSaleCount: Number(data.total_sale_count) || 0,
    totalSaleValue: Number(data.total_sale_value) || 0,
    paymentMethods,
    totalReceivedCount: Number(data.total_received_count) || 0,
    totalReceivedValue: Number(data.total_received_value) || 0,
    cashSale: Number(data.cash_sale) || 0,
    bankSaleAuto: Number(data.bank_sale_auto) || 0,
    fromRpc: true,
  };
}

/**
 * Fast Z Report totals via Postgres RPC (sale summary + payment methods).
 * Returns null when RPC is unavailable.
 */
export async function fetchZReportTotalsRpc(dateFrom, dateTo, gymId = '') {
  const from = String(dateFrom || '').slice(0, 10);
  const to = String(dateTo || '').slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(from) || !/^\d{4}-\d{2}-\d{2}$/.test(to)) return null;

  const gid = gymId || await ensureGymId().catch(() => '');
  if (!gid) return null;

  const { data, error } = await supabase.rpc('get_z_report_totals', {
    p_gym_id: gid,
    p_date_from: from,
    p_date_to: to,
  });
  if (error) {
    console.warn('get_z_report_totals RPC failed', error.message || error);
    return null;
  }
  return mapZReportRpcToAuto(data);
}
